module.exports = __webpack_public_path__ + "img/img_hp_interpretation@2x.4c223c9b.png";